export const dockerDefaultRepositoryUrl = 'https://docker.io'

export const passwordPlaceholder = '********'
